import { render, staticRenderFns } from "./BrMainContainer.vue?vue&type=template&id=3b50b29e&"
import script from "./BrMainContainer.vue?vue&type=script&lang=js&"
export * from "./BrMainContainer.vue?vue&type=script&lang=js&"
import style0 from "./BrMainContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports